export default ({ inputValue }) => ({
  endpoint: '/salesLeader/profile/validator?endpointCd=validatorSalesLeaderProfile',
  method: 'post',
  data: {
    profile: {
      vanityName: inputValue,
    },
  },
});
